import http from '@/api/http';

export const getMaterializedOptions = () => {
  return http.get('/api/v1/dashboards/materialized/options');
};

export const getTodayMaterialized = (locationId) => {
  return http.get('/api/v1/dashboards/materialized/today', {
    params: { location_id: locationId },
  });
};

export default {
  getMaterializedOptions,
  getTodayMaterialized,
};
